module.exports = __webpack_public_path__ + "static/media/ally_pro_4.e52e6ba4.jpg";